import "./supportServiceTile.scss";

import React from "react";
import { useTranslation } from "react-i18next";
import { LocalizedLink } from "../../primitives";

type SupportServiceTileProps = {
    textKey: string;
    titleTextKey: string;
    urlTextKey: string;
    url: string;
    image: JSX.Element;
};

export default function SupportServiceTile(props: SupportServiceTileProps) {
    const { textKey, titleTextKey, image, urlTextKey, url } = props;

    const { t } = useTranslation("templatePages");

    return (
        <div className="product-support-service-tile">
            <div className="product-support-service-tile-image">{image}</div>
            <div>
                <p className="product-support-service-tile-title">
                    <span>{t(titleTextKey)}</span>
                </p>
                <p className="product-support-service-tile-description">{t(textKey)}</p>
                <LocalizedLink to={url}>{t(urlTextKey)}</LocalizedLink>
            </div>
        </div>
    );
}
